// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__jbaK2","sendOtp":"AuthorizeToLogin_sendOtp__13oFQ"};